import type {UseQueryResult} from '@tanstack/react-query';
import {useQuery} from '@tanstack/react-query';
import useApiFetch from '@/components/MSAL/useApiFetch';
import type {CapacityConfig} from '@/types/CapacityConfig';
import {apiUrl} from '@/utils/api';

export const useGetCapacityDateConfig = () : UseQueryResult<CapacityConfig> => {
    const fetch = useApiFetch();

    return useQuery(['capacityDateConfig'], async ({signal}) => {
        const response = await fetch(
            apiUrl('/v1/capacity/capacity/config').toString(),
            {
                method: 'GET',
                signal,
            }
        );

        if (!response.ok) {
            throw new Error('Unable to fetch capacity date config.');
        }

        return await response.json() as CapacityConfig;
    });
};
